<template>
    <span>
        <span v-if="!showAll">
            {{ text | truncate(maxLength) }}
            <a href="javascript:void(0)"
               v-show="text.length > maxLength"
               @click="showAll = true">
                Show More
            </a>
        </span>
        <span v-if="showAll">
            {{ text }}
        </span>
    </span>
</template>

<script>
    import { truncate } from '../helpers/filters';

    export default {
        props: {
            text: {
                type: String,
                required: false,
                default: '',
            },
            maxLength: {
                type: Number,
                required: false,
                default: 100,
            }
        },
        filters: {
            truncate,
        },
        data() {
            return {
                showAll: false,
            }
        }
    }
</script>
